<template>
    <div>
        <Title :title="`回${ province }方式统计`" style="position:relative">
            <!-- <div class="totalNum">总人数：{{ totalNum }}人</div> -->
            <Echarts 
                :options="polar"
                style="width: 100%;height: 100%"
                autoresize
                v-if="ifShowEcharts"/>
        </Title>
    </div>    
</template>
<script>
import miment from 'miment';
import Echarts from "vue-echarts";
// 引入曲线图
require("echarts/lib/chart/line");
// 引入提示框和标题组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/grid");
require("echarts/lib/component/legendScroll");
require("echarts/lib/component/dataZoom");
import Title from './title'
export default {
    components: { Title,Echarts },
    data(){
        return {
            province: '',
            totalNum: 0,
            ifShowEcharts: false,
            polar:  {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: [
                        "自驾",
                        "飞机",
                        "火车",
                        "其他"
                    ],
                    top: "8",
                    right: 0,
                    textStyle: {
                        color: '#949a98'
                    }
                },
                grid: {
                    left: "0",
                    right: "0",
                    bottom: "15",
                    top: "50",
                    containLabel: true
                },
                xAxis: {
                    type: "category",
                    data: [],
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        color: "#959a9e"
                    },
                    axisLabel: {
                        color: "#959a9e",
                        interval: 0,
                        rotate: 30
                    },
                    splitLine: {
                        show: false
                    }
                },
                yAxis: {
                    type: "value",
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        color: "#959a9e"
                    },
                    axisLabel: {
                        color: "#959a9e"
                    },
                    splitLine: {
                        show: false
                    }
                },
                dataZoom: [
                    {
                        type: "inside",
                        startValue: 0,
                        endValue: 14
                    }
                ],
                series: [
                    {
                        name: "自驾",
                        type: "line",
                        smooth: true,
                        prop: "car",
                        barWidth: 22,
                        itemStyle: {
                            color: "#4f69c6"
                        },
                        data: []
                    },
                    {
                        name: "飞机",
                        type: "line",
                        smooth: true,
                        prop: "aircraft",
                        barWidth: 22,
                        itemStyle: {
                            color: "#6eab43"
                        },
                        data: []
                    },
                    {
                        name: "火车",
                        type: "line",
                        smooth: true,
                        prop: "train",
                        barWidth: 22,
                        itemStyle: {
                            color: "#ff2927"
                        },
                        data: []
                    },
                    {
                        name: "其他",
                        type: "line",
                        smooth: true,
                        prop: "other",
                        barWidth: 22,
                        itemStyle: {
                            color: "#20e7be"
                        },
                        data: []
                    }
                ]
            }
        }
    },
    props: {
        provinceShortName: {
            type: String
        },
        date: {
            type: String
        }
    },
    methods: {
        // 获取信息
        async getInfo(starttime,endtime){
            this.totalNum = 0;
            let res = await this.$get(this.urlobj.getEpidemicHBMobilityTrends,{
                communityId:this.$route.query.communityId || this.$store.state.streetorcommunityid,
                type: 1,
                beginTime: starttime,
                endTime: endtime
            })
            this.polar.xAxis.data = res.rows.map(item => {
                this.totalNum += Number(item.allCount);
                return  `${ item.daytime.split('-')[1] }-${ item.daytime.split('-')[2] }`
            })
            this.polar.dataZoom[0].endValue = res.rows.length - 1;
            this.polar.dataZoom[0].startValue = res.rows.length - 15;
            let list = [ 'car','aircraft','train','other' ]
            list.forEach(item => {
                this.polar.series.find(citem => citem.prop == item).data = res.rows.map(citem => citem[item]);
            })
            this.ifShowEcharts = true;
        }
    },
    watch: {
        provinceShortName(newVal){
            this.province = newVal;
        },
        date(newVal){
            let starttime,endtime

            

            if(newVal == '日期选择'){
                this.getInfo();
                return
            }

            if(newVal.length == 6){
                let year = newVal.substring(0,4);
                let month = newVal.substring(4);
                starttime = miment(year + '-' + month + '-' + '01').format('YYYY-MM-DD');
                endtime = miment(year + '-' + month + '-' + new Date(year,month,0).getDate()).format('YYYY-MM-DD');

                this.ifShowEcharts = false;
                this.getInfo(starttime,endtime)
            }else if(newVal.length == 8){
                let year = newVal.substring(0,4);
                let month = newVal.substring(4,6);
                let date = newVal.substring(6,7);
                starttime = miment(year + '-' + month + '-' + date).format('YYYY-MM-DD');
                endtime = miment(year + '-' + month + '-' + date).format('YYYY-MM-DD');
            
                this.ifShowEcharts = false;
                this.getInfo(starttime,endtime)
            }
        }
    },
    created(){
        this.getInfo();
    }
}
</script>
<style lang="less" scoped>
.totalNum {
    position: absolute;
    top: 48px;
    left: 20px;
    color: #fcfffd;
    font-size: 12px;
}

</style>